import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { setEntryDataState } from '../../actions/app/entryData.actions'
import brandSelector from '../../selectors/brandSelector'
import countrySelector from '../../selectors/i18n/countrySelector'
import languageSelector from '../../selectors/i18n/languageSelector'
import initParametersSelector from '../../selectors/initParametersSelector'
import isWhatfixEnabledSelector from '../../selectors/feature-scope/isWhatfixEnabledSelector'
import { getWhatfixSessionPseudonym, hasBrandScript, loadWhatfixScript, setWhatfixContext } from '../../../utils/whatfix'
import { mapCountryCodeToISO3 } from '../../../utils/countryCodeMapper'

const whatfixMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(setEntryDataState, action)) {
        const state = store.getState()

        if (!isWhatfixEnabledSelector(state)) {
            return
        }

        const brand = brandSelector(state)

        if (!hasBrandScript(brand)) {
            return
        }

        const country = countrySelector(state)
        const language = languageSelector(state)
        const market = mapCountryCodeToISO3(country)
        const tenant = initParametersSelector(state).contextId!
        const roles = [tenant]
        const pseudonym = getWhatfixSessionPseudonym()

        setWhatfixContext(market, language, roles, pseudonym)
        loadWhatfixScript(brand)
    }
}

export default whatfixMiddleware
